const URL1 = "https://tpabackend.talentpool-academy.in/api";
const URL2 = "http://localhost:8000/api";

export const baseURL = URL1;